import React from 'react'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material/'
import { FeedList } from '@components/organisms/Article/FeedList'
import { useGetArticlesCategoryQuery, ArticleFragment } from '@services/graphcms/client'

const PREFIX = 'RelateArticleContents'

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    marginTop: theme.spacing(4),
  },

  [`& .${classes.title}`]: {
    fontWeight: 550,
  },
}))

type Props = {
  article: ArticleFragment
}

export function RelateArticleContents(props: Props) {
  const { data, error, loading } = useGetArticlesCategoryQuery({
    variables: {
      skip: 0,
      first: 5,
      category: props.article.categories[0]?.title,
      categoryTitle: props.article.categories[0]?.title,
      articleId: props.article.id,
    },
  })

  if (loading || error || (data?.articles || []).length <= 0) {
    return null
  }

  return (
    <Root className={classes.container}>
      <Typography className={classes.title} variant="subtitle1">
        関連するトピック
      </Typography>
      {data?.articles &&
        data.articles?.map((article) => (
          <FeedList
            key={article.id}
            article={article}
            fullYear={true}
            isThumbnail={false}
            variant="elevation"
          />
        ))}
    </Root>
  )
}
